<script>
/**
 * Imports
 */
import SignupFormInput from "./SignupFormInput.vue";

/**
 * Component: Form: Group
 *
 * The component used for displaying the fields group.
 *
 * @author PH
 */
export default {
  props: ["title", "section", "fields", "section"],
  components: { SignupFormInput }
};
</script>

<template>
  <div class="signup-form-group">
    <div class="signup-form-group__title">
      <h3>{{title}}</h3>
    </div>

    <div class="signup-form-group__before">
      <slot name="beforeInputs"></slot>
    </div>

    <div class="signup-form-group__content">
      <signup-form-input
        v-for="input in fields"
        v-bind:key="input.id"
        v-bind:id="input.id"
        v-bind:options="input.options"
        v-bind:placeholder="input.placeholder"
        v-bind:description="input.description"
        v-bind:type="input.type"
        v-bind:validations="input.validations"
        v-bind:settings="input.settings"
        v-bind:section="section"
      ></signup-form-input>
    </div>

    <div class="signup-form-group__after">
      <slot name="afterInputs"></slot>
    </div>
  </div>
</template>

